import { ContactMe } from "../components/ContactMe";

function Contact({ id }) {
  return (
    <section id={id}>
      <ContactMe />
    </section>
  );
}

export default Contact;
